<template lang="pug">
    .login
        Layout
            Content.loginContent(:style="loginPageContentStyle")
                div(:style="backgroundLogoStyle")
                    Card.loginCard(dis-hover)
                        img(src="" v-real-img="loginImgs.loginFormLogoImgName" style="min-width:300px; max-width: 350px;margin: 10px 0;")
                        Divider
                        p.loginDescription Just to make sure it's really you.
                        p.loginDescription Check your Email: {{email}}
                        Form.loginInput(v-model="form")
                            FormItem(prop="token")
                                Input(type="text" placeholder="Please enter token" v-model="form.token")
                            FormItem
                                Button.loginBtn(@click="verifyUserLoginValidationMail") Verify
                        div(style="text-align: right")
                            a(@click="logout") Return to Login
                            Divider(type="vertical")
                            span(v-if="countdown>0") Resend Mail in {{countdown}} second(s)
                            a(@click="resendUserLoginValidationMail" v-else) Resend Mail
</template>
<script>
import { sendUserLoginValidationMail, verifyUserLoginValidationMail, getUserData, _logout } from "@/api/user";

export default {
    name: "VerifyDevice",
    data() {
        return {
            email: this.$store.state.userData.email,
            form: { token: "" },
            countdown: 60,
        };
    },
    methods: {
        sendUserLoginValidationMail() {
            sendUserLoginValidationMail({ taskNo: this.$store.state.userData.validateNewEquip.taskNo })
                .then((res) => {
                    if (!res.data.success) {
                        throw new Error(res.data.message);
                    }
                    this.countdown = 60;
                    this.countDownTimer();
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        verifyUserLoginValidationMail() {
            if (this.form.token == "") {
                this.$Notice.warning({
                    title: this.$i18n.t("global.error"),
                    desc: "Please fill in token.",
                });

                return;
            }

            verifyUserLoginValidationMail({
                taskNo: this.$store.state.userData.validateNewEquip.taskNo,
                token: this.form.token,
            })
                .then(async (res) => {
                    if (!res.data.success) {
                        if (res.data.msg !== "task expired.") {
                            throw new Error(res.data.msg);
                        } else {
                            this.$store.commit("SET_USER_DATA", {});
                            this.$router.push({ name: "login" });
                        }
                    }

                    await this.getUserData();

                    this.$router.push({
                        path: "/account-info/security",
                    });
                })
                .catch((err) => {
                    this.$Notice.warning({
                        title: this.$t("global.error"),
                    });
                });
        },
        async getUserData() {
            await getUserData()
                .then((res) => {
                    this.$store.commit("SET_USER_DATA", res.data);
                    // console.log("getUserData", this.$store.state.userData);
                })
                .catch((err) => {
                    this.$store.commit("SET_USER_DATA", {});
                    this.$router.push({ name: "login" });
                });
        },
        logout() {
            _logout()
                .then((response) => {
                    this.$store.commit("SET_USER_DATA", {});
                    this.$store.commit("LOGOUT");
                    window.location.reload();
                    this.$router.push({ name: "login" });
                })
                .catch((errors) => {
                    this.$store.commit("SET_USER_DATA", {});
                    this.$router.push({ name: "login" });
                });
        },
        countDownTimer() {
            if (this.countdown > 0) {
                setTimeout(() => {
                    this.countdown -= 1;
                    this.countDownTimer();
                }, 1000);
            }
        },
        resendUserLoginValidationMail() {
            if (this.countdown > 0) {
                return;
            }
            this.sendUserLoginValidationMail();
        },
    },
    computed: {
        loginPageContentStyle() {
            return {
                background: `url(${this.loginImgs.backgroundImgName}) no-repeat center center`,
                overflow: "hidden",
                "background-size": "cover",
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
                "background-color": this.loginImgs.backgroundImgName ? `none` : `#101820`,
            };
        },
        backgroundLogoStyle() {
            return {
                width: "100vw",
                height: "100vh",
                background: `url(${this.loginImgs.backgroundLogoImgName}) no-repeat center center`,
                "background-size": "auto 90%",
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
            };
        },
        loginImgs: function () {
            return this.$store.getters.getLoginPageImgs;
        },
        resendMail() {
            this.countdown > 0 ? true : false;
        },
    },
    async created() {
        await this.getUserData();
        this.sendUserLoginValidationMail();
    },
    mounted() {},
};
</script>

<style scope>
.loginFormLogoImgBlock {
    width: 350px;
    height: 80px;
    background: grey;
}
.loginCard {
    background: transparent;
    border: none;
    text-align: center;
}
.ivu-input-wrapper >>> .ivu-input-suffix {
    padding-right: 15px;
}

.ivu-input-wrapper >>> .ivu-input-suffix i {
    line-height: 40px;
}
.loginDescription {
    font-size: 28px;
    color: #fff;
    margin-bottom: 24px;
}
.loginDescriptionBlock {
    width: 350px;
    height: 40px;
    background: grey;
    margin-bottom: 24px;
}
@media screen and (min-width: 1280px) {
    .login-description {
        font-size: 28px;
    }
}
@media (max-width: 1080px) and (min-width: 960px) {
    .login-description {
        font-size: 24px;
    }
}
@media screen and (max-width: 960px) {
    .login-description {
        font-size: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/general/VerifyDevice.vue